import moment from 'moment'

function addResourceJournalRecordToDay(result, record){
    const recordDate = moment.unix(record.created_at || record.finished_at)
    const recordStartDay = recordDate.startOf('day')
    const recordStartDayUnix = recordStartDay.valueOf()

    if (result[recordStartDayUnix] === undefined){
        result[recordStartDayUnix] = []
    }
    const dayRecords = result[recordStartDayUnix]
    dayRecords.date = recordStartDay

    dayRecords.push(record)

    return result
}

function calculateResourceTotal(dayRecordsArray){
    dayRecordsArray.resourceTotal = dayRecordsArray.reduce((total, record) => {
        if (record.ir_delta){
            return total + record.ir_delta
        }
        return total
    }, 0)
}

export function groupResourceJournalByDay(records) {
    records.days = records.data.reduce(addResourceJournalRecordToDay, {})
    Object.keys(records.days).forEach(day => {
        calculateResourceTotal(records.days[day])
    })
    return records
}



// WEBPACK FOOTER //
// ./helpers/journal.js